import { render, staticRenderFns } from "./ConfigUsers.vue?vue&type=template&id=cff84d9a&scoped=true&"
import script from "./ConfigUsers.vue?vue&type=script&lang=js&"
export * from "./ConfigUsers.vue?vue&type=script&lang=js&"
import style0 from "./ConfigUsers.vue?vue&type=style&index=0&id=cff84d9a&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cff84d9a",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!/home/runner/_work/studio/studio/node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib'
import { VCombobox } from 'vuetify/lib'
import { VDataTable } from 'vuetify/lib'
import { VForm } from 'vuetify/lib'
import { VPagination } from 'vuetify/lib'
installComponents(component, {VBtn,VCombobox,VDataTable,VForm,VPagination})
